import { render, staticRenderFns } from "./Link.vue?vue&type=template&id=1747ea1a&scoped=true&"
import script from "./Link.vue?vue&type=script&lang=ts&"
export * from "./Link.vue?vue&type=script&lang=ts&"
import style0 from "./Link.vue?vue&type=style&index=0&id=1747ea1a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1747ea1a",
  null
  
)

export default component.exports